import React, { PropsWithChildren, ReactElement, useContext } from 'react'
import { Link } from 'react-router'

import PackageLock from '../../components/widgets/PackageLock'
import { UserReducer } from '../../reducers/user'
import { getAllParentsForCurrentPath, getMainMenuIntegrationMenu, MenuContext } from '../../utils/menu-utils'
import { connectToReducer } from '../../utils/reducer-utils'
import { RoutePropsLocation } from '../../utils/route-utils'
import { t } from '../../utils/translation-utils'

import './SubmenuLayout.css'

type Reducers = {
  user: UserReducer
}

type Props = PropsWithChildren<{
  location: RoutePropsLocation
  className?: string
}>

function IntegrationsLayout(props: Reducers & Props): ReactElement | null {
  const { menu } = useContext(MenuContext)
  const activePath = getAllParentsForCurrentPath(props.location.pathname).map((i) => i.id)

  return (
    <div className={'with-submenu integrations-layout' + (props.className ? ' ' + props.className : '')}>
      {!props.user.user?.uiSettings.sideMenu && (
        <div className="submenu">
          {getMainMenuIntegrationMenu(menu).map((item) => {
            if (item.type !== 'item-label') {
              return null
            }
            if (item.packageLock) {
              return (
                <PackageLock key={item.id} packageGroups={item.packageLock}>
                  <Link to={item.link} className={activePath.includes(item.id) ? 'active' : ''}>
                    {t(item.labelID)}
                  </Link>
                </PackageLock>
              )
            }
            return (
              <Link key={item.id} to={item.link} className={activePath.includes(item.id) ? 'active' : ''}>
                {t(item.labelID)}
              </Link>
            )
          })}
        </div>
      )}
      <div className="with-submenu-main">{props.children}</div>
    </div>
  )
}

export default connectToReducer<Reducers, any, Props>(
  (state) => ({
    user: state.user,
  }),
  {}
)(IntegrationsLayout)
